import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useJwt } from "react-jwt";
import Sidebar from "../components/Sidebar";
import { Icon } from 'react-icons-kit';
import { eye } from 'react-icons-kit/feather/eye';
import { useEffect, useState } from "react";
import { GetNotificationById } from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";

function ViewNotification() {
    const navigate = useNavigate();
    const [notificationData, setNotificationData] = useState(null);
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');
    
  const { notificationid } = useParams();
  const [loading, setLoading] = useState(false);
    
    const formatUTCDate = (utcDateString) => {
      const date = new Date(utcDateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
      hours = String(hours).padStart(2, "0");

      return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    useEffect(() => {
        (
          async () => {
            setLoading(true);
                try {
                    const response = await GetNotificationById(notificationid, localStorage.getItem("accessToken"));
                    setLoading(false);
                    setNotificationData(response?.data?.response)
                } catch (error) {
                  console.log(error);
                } finally {
                  setLoading(false);
                }
            }
        )();
    }, []);

    return (
      <div className="dashboard-content">
        <Sidebar />

        <div className="body-cart tab-content dasContent p-4 bg-white rounded">
          <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
            <h1 className="heading h4 mb-0 fw-bold">Notification Details</h1>
            <div className="d-inline-flex gap-2">
              <NavLink to="/notification" className="btn btn-primary addSeller">
                <Icon className="eye" icon={eye} size={18} /> View All
              </NavLink>
            </div>
          </div>
          {
            loading ?
              <div className="d-flex align-items-center justify-content-center">
                <RiLoaderFill size={40} className="text-success spin-animation text-center" />
              </div>
              :
              <div className="detailsBox">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover w-100">
                        <tbody>
                          <tr>
                            <th>Title</th>
                            <td>{notificationData?.title}</td>
                          </tr>
                          <tr>
                            <th>Description</th>
                            <td>{notificationData?.shortdescription}</td>
                          </tr>
                          <tr>
                            <th>Start Date</th>
                            <td>{formatUTCDate(notificationData?.selecteddate)}</td>
                          </tr>
                          {notificationData?.enddate && (
                            <tr>
                              <th>End Date</th>
                              <td>{formatUTCDate(notificationData?.enddate)}</td>
                            </tr>
                          )}
                          {notificationData?.scheduledtime && (
                            <tr>
                              <th>Scheduled Time</th>
                              <td>
                                {notificationData?.scheduledtime
                                  ? new Date(
                                    `1970-01-01T${notificationData.scheduledtime}:00`
                                  ).toLocaleTimeString([], {
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                  : ""}
                              </td>
                            </tr>
                          )}
                          <tr>
                            <th>Created By</th>
                            <td>{notificationData?.createdby}</td>
                          </tr>
                          <tr>
                            <th>Modified By</th>
                            <td>{notificationData?.modifiedby}</td>
                          </tr>
                          <tr>
                            <th>Created Date</th>
                            <td>{formatUTCDate(notificationData?.createddate)}</td>
                          </tr>
                          <tr>
                            <th>Modified Date</th>
                            <td>{formatUTCDate(notificationData?.modifieddate)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
          }
        </div>
      </div>
    );

}

export default ViewNotification;